import React from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";
import DotsComponent from "../../DotsComponent";

const data = [
  {
    name: "2013",

    marketing: 8000,
    branding: 2400,
    amt: 2000
  },
  {
    name: "2014",
    marketing: 3000,
    branding: 1398,
    amt: 2210
  },
  {
    name: "2015",
    marketing: 2000,
    branding: 9800,
    amt: 2290
  },
  {
    name: "2016",
    marketing: 2780,
    branding: 3908,
    amt: 2000
  },
  {
    name: "2017",
    marketing: 1890,
    branding: 4800,
    amt: 2181
  },
  {
    name: "2018",
    marketing: 2390,
    branding: 3800,
    amt: 2500
  },
  {
    name: "2019",
    marketing: 3490,
    branding: 4300,
    amt: 2100
  },
  {
    name: "2020",
    marketing: 3490,
    branding: 4300,
    amt: 2100
  },
  {
    name: "2021",
    marketing: 9890,
    branding: 4300,
    amt: 2100
  },
  {
    name: "2022",
    marketing: 4490,
    branding: 4300,
    amt: 2100
  }
];

export default function Chart() {
  return (
    <div>
    <div className="graph">
      <DotsComponent/>
            <div className="graph_heading">
              <h1 className="Graph_title">SALARY STATISTICS</h1>
              {/* <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon> */}
            </div>
          </div>
    <LineChart
      width={700}
      height={250}
      data={data}
      margin={{
        top: 30,
        right: 30,
        left: 20,
        bottom: 0
      }}
    >
      <XAxis dataKey="name" />
      <YAxis />
      <Tooltip />
      <Legend />
      <Line
        type="monotone"
        dataKey="marketing"
        stroke="#8884d8"
        activeDot={{ r: 8 }}
        dot={false}
      />
      <Line dot={false} type="monotone" dataKey="branding" stroke="#82ca9d" />
    </LineChart>
    </div>
  );
}
